import { AuthContext } from "@contexts/auth/AuthContext";
import { CompanyContext } from "@contexts/company/CompanyContext";
import { SettingsContext } from "@contexts/settings/SettingsContext";
import { useContext } from "react";

export const bannerStorageKey = "BSK";

export function useTopBar() {
  const { isValid, showBanner, setIsValid, setShowBanner } = useContext(AuthContext);
  const { currentCompany } = useContext(CompanyContext);
  const { setCompanyModalOpen, setProfileModalOpen } = useContext(SettingsContext);

  const isAllowed = false;

  return {
    currentCompany,
    isValid,
    showBanner: isAllowed && showBanner,
    setCompanyModalOpen,
    setIsValid,
    setProfileModalOpen,
    setShowBanner,
  };
}
